import { capi } from "..";
import { QualityferDTOout } from "./DTOs/qualityferDTOout";
import { QualityferMortgageDTOin } from "./DTOs/qualityferMortgageDTOin";

export const qualityferMortgage = (qualityferMortgageDTOin: QualityferMortgageDTOin): Promise<QualityferDTOout> => {
    return capi.post('/thirdparty/qualityfer-mortgage', qualityferMortgageDTOin);
}